var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3132,
    height: 3719,
    viewBox: "0 0 3132 3719",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF2E24"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB2927"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 195.737,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D63231"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 195.737,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE302D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 195.737,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB2927"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 195.737,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E82127"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 391.474,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D23732"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 391.474,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB302C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 391.474,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA2F2A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 391.474,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EA4335"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 587.211,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC2D29"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 587.211,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D43532"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 587.211,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF3430"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 587.211,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D53833"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD2A2B"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D63231"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D0312E"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC2D29"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 782.947,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB3127"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC332D"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB2927"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D1322C"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E98015"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF322D"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB302B"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 978.684,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D23530"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D12F2D"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC332D"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC2F2A"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C92A27"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC831A"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F28528"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF322D"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 1174.42,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D2302E"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D43532"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D13832"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D12F2D"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D33532"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D13327"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EA821F"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E77C14"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D22C2C"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D53833"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 1370.16,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#B63724"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D1322F"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD342E"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 587.21,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D33631"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF312E"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D13330"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F1881F"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E7801B"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F18C22"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F48825"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA2D28"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.1,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EA4335"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D53B33"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 1565.89,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE302D"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC312C"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 587.21,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC332D"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD3329"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F5832D"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EF861D"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F2891E"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E9821B"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F28621"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D1342F"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.1,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EA4335"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D3312E"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD2F2C"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 1761.63,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CC2F2A"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D7342D"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF3631"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C92B28"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 587.21,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D63932"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C72A25"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E8801D"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E67914"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F4CE3D"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E97E14"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#ED831F"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF302D"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.1,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD3029"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C22820"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE2C2A"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 1957.37,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C9302A"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CE332F"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D03731"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE851A"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 587.21,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C83022"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE801F"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#ED8621"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F6C634"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F8CE3E"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB8519"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE8722"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CB2B2B"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.1,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD2F26"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB8520"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD2826"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D23733"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 2936.05,
    y: 2153.1,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E82127"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF312E"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D0312D"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#ED861F"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 587.21,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F08622"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC871F"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB841D"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F5CC3C"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#FAD040"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EECA38"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE851C"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D23530"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.1,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EB841F"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E8821D"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C63216"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D43730"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 2936.05,
    y: 2348.84,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#B5341E"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA2F2B"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D12C2A"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E87E18"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 587.21,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC8421"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE831B"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E48217"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F1CB3A"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F5CC40"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F2CA35"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F0851B"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#ED8A22"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.1,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#ED861F"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E8821D"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DD5428"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C92E29"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 2936.05,
    y: 2544.58,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D22E2C"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D2302E"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC801B"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 587.21,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E97F19"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#FCCE3D"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F2CB42"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F2C93B"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F6C93A"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F1CA3E"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#FCD549"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EC821C"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.1,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EF8A20"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E5821A"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA2826"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 2740.32,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D53831"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C82925"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C73319"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 587.21,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F08422"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F3CB38"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F1C838"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F8CD40"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F5CC3E"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F6CE3B"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F9CF3F"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F0C93D"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.1,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE7F16"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E87F16"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D12F2A"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 2740.32,
    y: 2936.05,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA2B28"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 195.736,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 391.474,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CA3028"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 587.21,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#FA7D3B"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EF841A"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F6CC3C"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F6CD41"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F4C93C"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F5CC40"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F8D03D"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F1C933"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.1,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EF841C"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D4302F"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 2544.58,
    y: 3131.79,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CF2C2D"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 587.21,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D4302F"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 782.947,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#CD3329"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EE881C"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F5CD37"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F5CB37"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#EECE3B"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DD9620"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 1957.37,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#F2712D"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 2153.1,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D4322F"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 2348.84,
    y: 3327.53,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E82127"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 978.684,
    y: 3523.26,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D83435"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 1174.42,
    y: 3523.26,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#DE3340"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 1370.16,
    y: 3523.26,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#D83435"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 1565.89,
    y: 3523.26,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#C12E27"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 1761.63,
    y: 3523.26,
    width: 195.737,
    height: 195.737,
    rx: 97.8684,
    fill: "#E82127"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire1);
export default __webpack_public_path__ + "static/media/Fire1.147701f3f1740e55ef3522ff584c6048.svg";
export { ForwardRef as ReactComponent };